import urls from '../urls';
import CONSTANTS from '../../constants';
const httpStatus = require('http-status-codes');

// TODO: This file should be refactored into intermediate form component
// TODO: Ticket: https://leadgenius.atlassian.net/browse/DASH-2584

/* Add spaces around parentheses */
function getFomattedPhoneValue(value) {
    return value.replace(/([^\s])\s*\(/g, "$1 (").replace(/\)([^\s])/g, ") $1");
}

/* Return target field choice based on source field value */
function _getSelectedFieldChoice(sourceValue, choices) {
    const sourceValueInt = parseInt(sourceValue);
    if (isNaN(sourceValueInt)) return;

    const replacementMap = {',': '', '$': '', 'M': '000000', 'B': '000000000'};
    for (const choice of choices) {
        // Converting choice value to pair of two integers
        let pair = choice.caption;
        pair = pair.replace(/,|\$|M|B/gi, matched => replacementMap[matched]);
        pair = pair.split('-');
        const left = parseInt(pair[0]);
        const right = parseInt(pair[1]);
        if (!isNaN(left) && left <= sourceValueInt && (isNaN(right) || sourceValueInt <= right)) {
            return choice.caption;
        }
    }
}

/**
 * This function provides connection between two fields (source -> target).
 * It selects target field choice based on inputed source field value.
 */
function updateChoiceOnSourceUpdate(context, sourceValue, targetKey) {
    const fields = context.state.recordForm.fields;
    const selectField = fields.find(f => f.key === targetKey);
    if (selectField) {
        const choice = _getSelectedFieldChoice(sourceValue, selectField.choices) || selectField.value;
        context.commit('recordForm/setFieldAttr', [targetKey, 'value', choice]);
    }
}

function processFieldValueUpdate(context, [key, value]) {
    if (key === CONSTANTS.FIELDS.PHONE.key) {
        context.commit('recordForm/setFieldAttr', [key, 'value', getFomattedPhoneValue(value)]);
    }
    if (key === CONSTANTS.FIELDS.NUM_EMPLOYEES_EXACT.key) {
        updateChoiceOnSourceUpdate(context, value, CONSTANTS.FIELDS.NUM_EMPLOYEES.key)
    }
    if (key === CONSTANTS.FIELDS.ESTIMATED_REVENUE.key) {
        updateChoiceOnSourceUpdate(context, value, CONSTANTS.FIELDS.ANNUAL_REVENUE.key)
    }
}

function initFields(context) {
    const accountFields = context.rootGetters['worker/recordDetailSession/accountFields'];
    // LG-12171 - limit to exclusion field
    const exclusionAccountFields = accountFields.filter(field => field.exclusion);
    context.dispatch('recordForm/initFields', exclusionAccountFields);

    // Apply changes for account specific fields logic
    const fields = context.state.recordForm.fields;
    // Make industry field multi-select
    const industryField = fields.find(f => f.key === CONSTANTS.FIELDS.INDUSTRY.key);
    if (industryField) {
        context.commit('recordForm/setFieldAttr', [industryField.key, 'type', 'multi-select']);
        context.commit('recordForm/setFieldAttr', [industryField.key, 'industry_type', accountFields.find(f => f.key === CONSTANTS.FIELDS.INDUSTRY.key).industry_type]);
        const choices = industryField.choices.map(c => c.key);
        context.commit('recordForm/setFieldAttr', [industryField.key, 'choices', choices]);
    }
    // Add allowed characters list to specific fields
    const estimatedRevenueField = fields.find(f => f.key === CONSTANTS.FIELDS.ESTIMATED_REVENUE.key);
    if (estimatedRevenueField) {
        const validChars = '0123456789$'.split('');
        context.commit('recordForm/setFieldAttr', [estimatedRevenueField.key, 'validChars', validChars]);
    }
    const numEmployeesExactField = fields.find(f => f.key === CONSTANTS.FIELDS.NUM_EMPLOYEES_EXACT.key);
    if (numEmployeesExactField) {
        const validChars = '0123456789'.split('');
        context.commit('recordForm/setFieldAttr', [numEmployeesExactField.key, 'validChars', validChars]);
    }
}

export default {
    getFomattedPhoneValue,
    updateChoiceOnSourceUpdate,
    processFieldValueUpdate,
    initFields,
};
